// Map buttons (spec 15c §3.6): home, zoom in and out, the whole galaxy.
import { House, Maximize2, Minus, Plus } from 'lucide-react';
import { IconButton } from '../ui';

const button = 'hud-cut-sm border border-line bg-panel/85 backdrop-blur';

export function MapControls({
  onHome,
  onZoomIn,
  onZoomOut,
  onFit,
}: {
  onHome?: (() => void) | undefined;
  onZoomIn(): void;
  onZoomOut(): void;
  onFit(): void;
}) {
  return (
    <div className="absolute top-1/2 right-2 z-30 flex -translate-y-1/2 flex-col gap-1">
      {onHome ? (
        <IconButton label="Go to home system" className={button} onClick={onHome}>
          <House className="size-5" />
        </IconButton>
      ) : null}
      <IconButton label="Zoom in" className={button} onClick={onZoomIn}>
        <Plus className="size-5" />
      </IconButton>
      <IconButton label="Zoom out" className={button} onClick={onZoomOut}>
        <Minus className="size-5" />
      </IconButton>
      <IconButton label="Show the whole galaxy" className={button} onClick={onFit}>
        <Maximize2 className="size-5" />
      </IconButton>
    </div>
  );
}
